import { css } from 'styled-components';
import token from 'styled-token';
import { StyledVerticalNavList } from '../../components/VerticalNavList/VerticalNavList.styles';

/** @class VerticalNavMixin */
/** @method */

export var VerticalNavMixin = function VerticalNavMixin(props) {
  var border = props.border,
    background = props.background,
    navElevation = props.navElevation;
  return token({
    boxShadow: 'VerticalNav.boxShadow',
    backgroundColor: 'VerticalNav.backgroundColor',
    borderColor: 'VerticalNav.borderColor',
    borderRadius: 'VerticalNav.borderRadius'
  }, function (_ref) {
    var boxShadow = _ref.boxShadow,
      backgroundColor = _ref.backgroundColor,
      borderColor = _ref.borderColor,
      borderRadius = _ref.borderRadius;
    return css(["box-sizing:border-box;display:flex;flex-direction:column;background-color:", ";box-shadow:", ";", " ", " ", "{> *{&:first-child{border-top-left-radius:", "px;}&:last-child{border-bottom-left-radius:", "px;}}}"], background ? backgroundColor : 'transparent', navElevation ? boxShadow : 'none', background && "border-radius: " + borderRadius + "px;", border && "border: 1px solid " + borderColor + ";", StyledVerticalNavList, background ? borderRadius : 0, background ? borderRadius : 0);
  });
};